import { css } from '@emotion/react';
import React from 'react';
import { ProcessStep } from './ProcessStep';
import { TFormStep } from '../screens/booking/formSteps';
import { BOOKING_BASE } from 'routes';

import { useQuery } from 'urql';
import { QUERY_REQUEST_STATE } from 'queries/queries-booking';

import { SpinnerBlock } from 'components/SpinnerBlock';
import { getEventDays } from 'screens/booking/hooks/useEventDays';

export const Process = ({
	steps,
	// currentStep,
	stepsDone,
	confirmed,
	id,
	eventDate,
}: {
	steps: TFormStep[];
	// currentStep: number;
	stepsDone: number;
	confirmed?: boolean;
	id: string;
	eventDate: Date;
}) => {
	// const { stepUrl } = useParams<BookingUrlParams>();

	const [requestStateResult] = useQuery({
		query: QUERY_REQUEST_STATE,
		variables: {
			url: id,
		},
	});

	// console.log('Steps', steps);

	const { data, fetching } = requestStateResult;

	return (
		<div
			css={css`
				display: flex;
				flex-direction: column;
			`}
		>
			{fetching ? (
				<div>
					<SpinnerBlock />
				</div>
			) : (
				<>
					{!!data &&
						steps?.map((item: TFormStep, index) => {
							const stepState = data.requestState.find((element: any) => element.id === item.link);

							if (confirmed && !item.visibleAfterConfirm) return null;

							// console.log('Nav link', item.link, stepState);

							const { isUrgent } = getEventDays({
								event_date: eventDate,
								isCompleted: stepState?.finished,
							});

							return (
								<ProcessStep
									to={BOOKING_BASE + id + '/' + item.link}
									isDisabled={stepsDone < index}
									isIncomplete={
										!stepState?.finished &&
										(index === 3 || index === 4 || index === 5 || index === 6) &&
										stepsDone > 3
									}
									isDone={stepState?.finished || (confirmed && index === 7)}
									key={index}
									hasStateIcon={index > 0 && index < steps.length}
									isUrgent={isUrgent}
									canBeFilledLater={item.canBeFilledLater}
								>
									{item.label}
								</ProcessStep>
							);
						})}
				</>
			)}
		</div>
	);
};
